// extracted by mini-css-extract-plugin
module.exports = {"successImageContainer":"ThankYou-module__successImageContainer___3b5n4"};